module.exports = __webpack_public_path__ + "graphic-d5f62dc7554756c420dcf75f4c06f7b2.png";